// extracted by mini-css-extract-plugin
export var disabled = "_f-a";
export var hierarchyLinkGray = "_f-4";
export var hierarchyLinkUnderline = "_f-3";
export var hierarchyPrimary = "_f-0";
export var hierarchySecondary = "_f-1";
export var hierarchyTertiary = "_f-2";
export var pressed = "_f-6";
export var themeAction = "_f-5";
export var themeDestructive = "_f-8";
export var themeNormal = "_f-7";
export var themeSuccess = "_f-9";